import { Panel, Search } from '@watcherr/ui';
import * as React from 'react';
import { t } from '~/i18n';

const PermissionGrantedTable = () => {
  const [search, setSearch] = React.useState('');

  return (
    <div>
      <Panel.Title>{t('permissions.form.grantedTable')}</Panel.Title>
      <Search value={search} onSearchChange={setSearch} />
    </div>
  );
};

export default PermissionGrantedTable;
